export default "__VITE_ASSET__CWaTedcM__"